
import Vue, {PropOptions, PropType} from "vue";
import {CHF} from "kistenkonfigurator/build/util/currency-util";
import {ProductDTO} from "../../model/rest/data-contracts";

export default Vue.extend({
  name: "PriceDisplay",

  props: {
    product: {
      type: Object as PropType<ProductDTO>,
      required: true,
    },
    showAb: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
  computed: {
    priceText(): string {
      if (this.product.price == null) {
        return "";
      }

      const price = CHF(this.product.price);
      return price.format();
    },
  },
});
